<div class="header-container">
    <div class="logo-container">
        <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
            <nb-icon icon="menu-2-outline"></nb-icon>
        </a>
        <img [src]="logo" alt="logo" height="32" (click)="navigateHome()" />
    </div>
    <div class="title-container">
        <span id="title">Portal de Compras</span>
        <span id="version">V5.17</span>
    </div>
</div>

<div class="header-container">
    <nb-actions size="small">
        <nb-action icon="color-palette-outline" class="theme-action" [nbContextMenu]="themes" nbContextMenuTag="theme-switcher"></nb-action>
        <nb-action class="user-action" *ngIf="isReady">
            <nb-user nbContextMenuTag="user-menu" [nbContextMenu]="userMenu" [onlyPicture]="userPictureOnly" [name]="userInfo.name" [title]="userInfo.title" picture="../../../../assets/images/user.png"></nb-user>
        </nb-action>
    </nb-actions>
    <!-- <ngx-chat-icon-buyer *ngIf="iconState"></ngx-chat-icon-buyer> -->
</div>